import React, { useEffect, useState } from 'react';
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../firebase";
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import 'slick-carousel/slick/slick.css';
import Slide from "../Slide/Slide";
import Main from "./recent";

const mediaTypes = ["movie", "tv", "people"];

const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div
            className="custom-arrow custom-prev"
            onClick={onClick}
            style={{
                position: 'absolute',
                top: '50%',
                left: '14px', // Adjust the left position as needed
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                zIndex: 1,
            }}
        >
            <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: '64px', color: 'white' }} />
        </div>
    );
};

const CustomNextArrow = (props) => {
    const { onClick } = props;
    return (
        <div
            className="custom-arrow custom-next"
            onClick={onClick}
            style={{
                position: 'absolute',
                top: '50%',
                right: '33px', // Adjust the right position as needed
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                zIndex: 1,
            }}
        >
            <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: '64px', color: 'white' }} />
        </div>
    );
};

const Recommendation = ({ theme }) => {
    const [MoviesGenres, setMoviesGenres] = useState([]);
    const [tvGenres, setTvGenres] = useState([]);
    const [upcomingTv, setUpcomingTv] = useState([]);
    const [upcomingMovies, setUpcomingMovies] = useState([]);
    const [filteredMedias, setFilteredMedias] = useState([]);
    const [favoriteError, setFavoriteError] = useState(null);
    const [favoriteLoading, setFavoriteLoading] = useState(false);
    const [movieHistory, setMovieHistory] = useState([]);
    const [tvHistory, setTvHistory] = useState([]);
    const [customMovies, setCustomMovies] = useState([]);
    const [commonGenreId, setCommonGenreId] = useState(null);
    const [commonGenreName, setCommonGenreName] = useState("");
    const [genreList, setGenreList] = useState([]);

    const textColor = theme === "dark" ? "white" : "black";
    const backgroundColor = theme === "dark" ? "black" : "white";

    const fetchGenres = async () => {
        try {
            const user = auth.currentUser;
            const isOnline = navigator.onLine;

            if (!user || !isOnline) {
                setFavoriteError("You are either not logged in or are currently offline. Please log in and connect to the internet.");
                return;
            }

            setFavoriteLoading(true);

            const userId = user.uid;
            const favoritesRef = doc(db, "userFavorite", userId);

            const favoritesDoc = await getDoc(favoritesRef);
            if (favoritesDoc.exists()) {
                const favoritesData = favoritesDoc.data().favorites || {};
                const genreCount = {};
                const uniqueGenreIds = new Set(); // Using a Set to store unique genreIds

                Object.values(favoritesData).forEach(({ mediaType, genres, genre }) => {
                    const genreIds = (genres || genre) ? (genres || genre).map(g => g.id) : [];
                    genreIds.forEach(id => {
                        if (!uniqueGenreIds.has(id)) {
                            uniqueGenreIds.add(id); // Add id to Set if it's not already present
                            genreCount[id] = (genreCount[id] || 0) + 1; // Count occurrences of each genreId
                        }
                    });
                });

                const finalUniqueGenreIds = Array.from(uniqueGenreIds).map(id => parseInt(id, 10));
                setMoviesGenres(prevValues => {
                    const newGenreIds = finalUniqueGenreIds.filter(id => !prevValues.includes(id));
                    return [...prevValues, ...newGenreIds];
                });

            } else {
                setFavoriteError("No favorites found.");
            }
        } catch (error) {
            console.error("Error fetching genres:", error);
            setFavoriteError("Error fetching genres. Please try again later.");
        } finally {
            setFavoriteLoading(false);
        }
    };

    const fetchGenresList = async () => {
        try {
            const response = await fetch(`https://api.themoviedb.org/3/genre/movie/list?api_key=4e44d9029b1270a757cddc766a1bcb63&language=en-US`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setGenreList(data.genres || []);
        } catch (error) {
            console.error("Error fetching genres:", error);
        }
    };

    const fetchSearchHistory = async () => {
        try {
            const user = auth.currentUser;
            if (!user) {
                console.error("No user is logged in.");
                return;
            }

            const userId = user.email; // Assuming user.email is used as the document ID
            const historyRef = doc(db, "history", userId);
            const historyDoc = await getDoc(historyRef);

            if (historyDoc.exists()) {
                const historyData = historyDoc.data();
                let movieHistoryData = [];
                let tvShowHistoryData = [];

                if (historyData.movies) {
                    movieHistoryData = historyData.movies.map(entry => parseInt(entry.movieId, 10));
                }
                if (historyData.tvShows) {
                    tvShowHistoryData = historyData.tvShows.map(entry => parseInt(entry.tvId, 10));
                }

                setTvHistory(tvShowHistoryData);
                setMovieHistory(movieHistoryData);

            } else {
                console.log("No search history found for the user.");
            }
        } catch (error) {
            console.error("Failed to fetch search history:", error);
        }
    };

    const fetchFavorites = async () => {
        try {
            const user = auth.currentUser;
            const isOnline = navigator.onLine;

            if (!user || !isOnline) {
                setFavoriteError("You are either not logged in or are currently offline. Please log in and connect to the internet.");
                return;
            }

            setFavoriteLoading(true);

            const userId = user.uid;
            const favoritesRef = doc(db, "userFavorite", userId);

            const favoritesDoc = await getDoc(favoritesRef);
            if (favoritesDoc.exists()) {
                const favoritesData = favoritesDoc.data().favorites || {};
                const genreCount = [];
                let genreIds = [];

                Object.values(favoritesData).forEach(({ mediaType, genres, genre }) => {
                    const genreIds = (genres || genre) ? (genres || genre).map(g => g.id) : [];
                    genreIds.forEach(id => {
                        genreCount[id] = (genreCount[id] || 0) + 1;
                    });
                });

                const genreId = [];
                Object.values(favoritesData).forEach(({ mediaType, genres, genre }) => {
                    const itemGenreIds = (genres || genre) ? (genres || genre).map(g => g.id) : [];
                    genreId.push(...itemGenreIds);
                });
                console.log("gennnnnnnnnnn......", genreId);

                const mostCommonGenreId = Object.keys(genreCount).reduce((a, b) => genreCount[a] > genreCount[b] ? a : b);
                setCommonGenreId(parseInt(mostCommonGenreId));
                setFilteredMedias(favoritesData);
            } else {
                setFavoriteError("No favorites found.");
            }
        } catch (error) {
            console.error("Error fetching favorites: ", error);
            setFavoriteError("Error fetching favorites. Please try again later.");
        } finally {
            setFavoriteLoading(false);
        }
    };

    useEffect(() => {
        const initialize = async () => {
            await fetchGenres();
            await fetchSearchHistory();
            await fetchFavorites();
            await fetchGenresList();
        };
        initialize();
    }, []);

    useEffect(() => {
        console.log("Common Movies Genre Name:", commonGenreName)
    }, [commonGenreName]);

    useEffect(() => {
        console.log("Genre List:", genreList);
        const genre = genreList.find(g => g.id === commonGenreId);
        console.log("genre : ", genre);
        if (genre) {
            setCommonGenreName(genre.name);
        }
    }, [genreList, commonGenreId]);

    useEffect(() => {
        const fetchUpcomingMovies = async () => {
            try {
                const totalPages = 5;
                let allMovies = [];
                let customFilteredMovies = [];
                const movieIds = new Set();

                for (let page = 1; page <= totalPages; page++) {
                    const response = await fetch(`https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=${page}&api_key=4aec7e88f4dca5e1ca73d50a3b06579a`);
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = await response.json();

                    let custom = data.results;
                    let filteredMovies = data.results;

                    if (movieHistory.length > 0) {
                        filteredMovies = filteredMovies.filter(movie => !movieHistory.includes(movie.id));
                    }

                    if (MoviesGenres.length > 0) {
                        const genreIdsToInclude = MoviesGenres.map(g => g);
                        filteredMovies = filteredMovies.filter(movie =>
                            movie.genre_ids.some(genreId =>
                                genreIdsToInclude.includes(parseInt(genreId, 10))
                            )
                        );
                    }

                    const customMoviesForPage = custom.filter(movie => movie.genre_ids.includes(commonGenreId));
                    customFilteredMovies = [...customFilteredMovies, ...customMoviesForPage];

                    filteredMovies.forEach(movie => {
                        if (!movieIds.has(movie.id)) {
                            allMovies.push(movie);
                            movieIds.add(movie.id);
                        }
                    });
                }

                setUpcomingMovies(allMovies);
                setCustomMovies(customFilteredMovies);

            } catch (error) {
                console.error("Error fetching upcoming movies:", error);
            }
        };

        const fetchUpcomingTv = async () => {
            try {
                const totalPages = 5;
                let allTv = [];
                const tvIds = new Set();

                for (let page = 1; page <= totalPages; page++) {
                    const response = await fetch(`https://api.themoviedb.org/3/tv/on_the_air?language=en-US&page=${page}&api_key=4aec7e88f4dca5e1ca73d50a3b06579a`);
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = await response.json();

                    let filteredTv = data.results;

                    if (tvHistory.length > 0) {
                        filteredTv = filteredTv.filter(tvShow => !tvHistory.includes(tvShow.id));
                    }

                    if (tvGenres.length > 0) {
                        filteredTv = filteredTv.filter(tvShow =>
                            tvShow.genre_ids.some(genreId => tvGenres.map(g => g.id).includes(genreId))
                        );
                    }

                    filteredTv.forEach(tvShow => {
                        if (!tvIds.has(tvShow.id)) {
                            allTv.push(tvShow);
                            tvIds.add(tvShow.id);
                        }
                    });
                }

                setUpcomingTv(allTv);
            } catch (error) {
                console.error("Error fetching upcoming TV shows:", error);
            }
        };

        fetchUpcomingMovies();
        fetchUpcomingTv();
    }, [commonGenreId, movieHistory, MoviesGenres, tvHistory, tvGenres]);

    const slickSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 924,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
    };

    return (
        <div className={`container ${theme}`} style={{ backgroundColor, minHeight: '100vh', color: textColor }}>
            <br />
            <br />
            <h2 style={{ paddingLeft: '3%', paddingRight: '3%', backgroundColor: theme === "dark" ? "#333" : "#ddd" }}>Recommended Movies</h2>
            <br />
            <Slider {...slickSettings} className="banner">
                {upcomingMovies.length > 0 ? (
                    upcomingMovies.map((movie, index) => (
                        <Slide key={movie.id} movie={movie} index={index} />
                    ))
                ) : (
                    <p>Loading...</p>
                )}
            </Slider>
            <br />
            <br />
            <h2 style={{ paddingLeft: '3%', paddingRight: '3%', backgroundColor: theme === "dark" ? "#333" : "#ddd" }}>Recommended Series</h2>
            <br />
            <Slider {...slickSettings} className="banner">
                {upcomingTv.length > 0 ? (
                    upcomingTv.map((tvShow, index) => (
                        <Slide key={tvShow.id} movie={tvShow} index={index} />
                    ))
                ) : (
                    <p>Loading...</p>
                )}
            </Slider>
            <br />
            <br />
            <Main />
            <br />
            <br />
            {commonGenreName ? (
                <>
                    <h2 style={{ paddingLeft: '3%', paddingRight: '3%', backgroundColor: theme === "dark" ? "#333" : "#ddd" }}> {commonGenreName} Genre</h2>
                    <br />
                    <Slider {...slickSettings} className="banner">
                        {customMovies.length > 0 ? (
                            customMovies
                                .filter(movie => !movieHistory.includes(movie.id)) // Filter out movies in the history
                                .filter(movie => MoviesGenres.length === 0 || movie.genre_ids.some(genreId => MoviesGenres.includes(parseInt(genreId, 10)))) // Filter based on genre
                                .map((movie, index) => (
                                    <Slide key={movie.id} movie={movie} index={index} />
                                ))
                        ) : (
                            <p>No upcoming movies found.</p>
                        )}
                    </Slider>
                </>
            ) : null}


            <br />
            <br />
            <br />
        </div>
    );
};

export default Recommendation;
